import { useSyncExternalStore } from 'react';

/** The value never changes after mount, so there is nothing to subscribe to. */
const subscribe = () => () => {};

/**
 * A value only the browser can know (device, OS, viewport), without making the server HTML depend
 * on it.
 *
 * `useSyncExternalStore` rather than `useState` + `useEffect`: React renders `serverValue` on the
 * server *and* through hydration, then re-renders with the browser's answer — so hydration matches
 * by construction.
 *
 * `getClientValue` must be stable across renders — define it at module scope, not inline.
 */
export function useClientValue<TValue>(getClientValue: () => TValue, serverValue: TValue): TValue {
    return useSyncExternalStore(subscribe, getClientValue, () => serverValue);
}
